var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',{attrs:{"label":_vm.label,"required":!!_vm.required}},[_c('Input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","disabled":!_vm.editable,"placeholder":_vm.config?.placeholder || '请输入',"rows":_vm._config.rows || 4},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }